import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Map, List } from 'immutable';

import Form from '../Form';

class CompetitionForm extends Form {
    static fieldsValidation = {
        name: [ 'required' ],
        'sport.id': [ 'required' ]
    };

    static propTypes = {
        ...Form.propTypes,
        sports: ImmutablePropTypes.map,

        onStepFinish: PropTypes.func
    };

    static defaultProps = {
        ...Form.defaultProps,
        sports: Map()
    };

    onSubmit(e) {
        e.preventDefault();
        Form.prototype.onSubmit.call(this, e);
    }

    renderForm() {
        const { sports, errors } = this.props;
        return (
            <div>
                {
                    this.getField(
                        <input
                            label={ 'Name' }
                            type="text"
                            { ...this.getFieldParameters('name') }
                        />
                    )
                }

                {
                    this.getField(
                        <select
                            label={ 'Sport' }
                            { ...this.getFieldParameters('sport.id') }
                        >
                            <option />
                            {
                                sports.map((s) => (
                                    <option key={ s.get('id') } value={ s.get('id') }>
                                        { s.get('name') }
                                    </option>
                                )).toArray()
                            }
                        </select>
                    )
                }

                { this.getCheckbox('active', 'Active') }
                { this.getCheckbox('display', 'Display') }

                { this.getBasicError(errors.get && errors.get('program')) }

                <div className="buttons">
                    <button type="submit" className="btn btn-primary" onClick={(e) => this.onSubmit(e)}>
                        Save
                    </button>
                </div>
            </div>
        );
    }
}

export default CompetitionForm;
